export const Functions = {
  create: false,
  delete: true,
  detail: true,
  search: true
};
export const PageName = '战略牵引额度回馈记录';